import React from "react";
import { FaPaperPlane, FaUserEdit, FaEdit, FaImage, FaCog, FaUsers, FaUserPlus, FaUserMinus, FaUserTimes, FaExchangeAlt } from "react-icons/fa";

const notifyColor = "#51a197";

const operacoes = [
  {
    key: "enviar",
    label: "Enviar Mensagem",
    icon: <FaPaperPlane color={notifyColor} size={28} />,
    tipo: "circle",
  },
  {
    key: "nome",
    label: "Mudar Nome",
    icon: <FaUserEdit color={notifyColor} size={24} />,
    tipo: "radio",
  },
  {
    key: "descricao",
    label: "Mudar Descrição",
    icon: <FaEdit color={notifyColor} size={24} />,
    tipo: "radio",
  },
  {
    key: "imagem",
    label: "Mudar Imagem",
    icon: <FaImage color={notifyColor} size={24} />,
    tipo: "radio",
  },
  {
    key: "config",
    label: "Mudar Configuração",
    icon: <FaCog color={notifyColor} size={24} />,
    tipo: "radio",
  },
  {
    key: "grupo",
    label: "Entrar no Grupo",
    icon: <FaUsers color={notifyColor} size={24} />,
    tipo: "radio",
  },
  {
    key: "addadmin",
    label: "Adicionar Administrador",
    icon: <FaUserPlus color={notifyColor} size={24} />,
    tipo: "radio",
  },
  {
    key: "remadmin",
    label: "Remover Administrador",
    icon: <FaUserMinus color={notifyColor} size={24} />,
    tipo: "radio",
  },
  {
    key: "remuser",
    label: "Remover participante",
    icon: <FaUserTimes color={notifyColor} size={24} />,
    tipo: "radio",
  },
  {
    key: "movecamp",
    label: "Mover grupos para uma nova campanha",
    icon: <FaExchangeAlt color={notifyColor} size={24} />,
    tipo: "radio",
  },
];

const Operacoes = ({ selected, setSelected, setEtapaAtual }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column", // Organiza o botão e o grid verticalmente
        justifyContent: "flex-start", // Alinha os itens ao topo
        alignItems: "center", // Centraliza horizontalmente
        minHeight: "100vh", // Garante que o componente ocupe a altura total da tela
        background: "#f7f7f7", // Cor de fundo para destacar o conteúdo
        padding: "10px", // Espaçamento interno
        boxSizing: "border-box",
      }}
    >
      {/* Botão Próximo */}
      <button
        style={{
          marginBottom: "20px", // Espaçamento entre o botão e o grid
          background: selected ? notifyColor : "#ccc", // Ativo apenas se uma operação estiver selecionada
          color: "#fff",
          border: "none",
          borderRadius: "8px",
          padding: "12px 24px",
          fontWeight: "bold",
          fontSize: "16px",
          cursor: selected ? "pointer" : "not-allowed", // Desabilita o clique se nenhuma operação estiver selecionada
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          transition: "background 0.3s",
        }}
        onClick={() => {
          if (selected) {
            setEtapaAtual(2); // Vai para a próxima etapa
          }
        }}
        disabled={!selected} // Desabilita o botão se nenhuma operação estiver selecionada
      >
        Próximo
      </button>

      {/* Grid de Operações */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", // Responsivo: mínimo 250px por item
          gap: "20px", // Espaçamento entre os itens
          justifyItems: "center", // Centraliza os itens horizontalmente
          alignItems: "center", // Centraliza os itens verticalmente
          width: "100%",
          maxWidth: "900px", // Limita a largura máxima do grid
        }}
      >
        {operacoes.map((op) => (
          <div
            key={op.key}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "16px",
              background: "#f7f7f7",
              borderRadius: "12px",
              padding: "14px 18px",
              width: "100%",
              maxWidth: "300px", // Limita a largura máxima de cada item
              boxSizing: "border-box",
              boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
            }}
          >
            <span
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minWidth: "38px",
              }}
            >
              {op.icon}
            </span>
            <span
              style={{
                flex: 1,
                fontWeight: "bold",
                color: "#005c53",
                fontSize: "16px",
                minWidth: 0,
              }}
            >
              {op.label}
            </span>
            {op.tipo === "radio" ? (
              <input
                type="radio"
                name="operacao"
                checked={selected === op.key}
                onChange={() => setSelected(op.key)}
                style={{
                  accentColor: notifyColor,
                  width: "22px",
                  height: "22px",
                  cursor: "pointer",
                }}
              />
            ) : (
              <button
                style={{
                  background: notifyColor,
                  border: "none",
                  borderRadius: "50%",
                  width: "32px",
                  height: "32px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
                }}
                onClick={() => {
                  setSelected(op.key);
                  setEtapaAtual(2);
                }}
                title="Enviar Mensagem"
              >
                <FaPaperPlane color="#fff" size={18} />
              </button>
            )}
          </div>
        ))}
      </div>
      <style>
        {`
          @media (max-width: 600px) {
            div[style*="grid-template-columns"] {
              grid-template-columns: 1fr !important; /* Força 1 coluna em telas menores */
            }
          }
        `}
      </style>
    </div>
  );
};

export default Operacoes;